import {RouteRecordRaw} from 'vue-router';

import RouteNames from "@/router/RouteNames.ts";
import TechnicianAppointmentUtils from "@/utils/common/TechnicianAppointmentUtils.ts";
import CapabilityType from "@/utils/constants/CapabilityType.ts";
import {SecuredRoute} from "@/router/RouteSecurity.ts";

const editViewTechnicianAppointments: SecuredRoute = {
  entity: TechnicianAppointmentUtils.APPOINTMENT_ENTITY,
  capabilities: [CapabilityType.RecordView]
};
const listViewTechnicianAppointments: SecuredRoute = {
  entity: TechnicianAppointmentUtils.APPOINTMENT_ENTITY,
  capabilities: [CapabilityType.ListView]
};

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import("@/views/Welcome.vue"),
    name: RouteNames.WELCOME_ROUTE
  }, {
    path: '/login',
    component: () => import("@/views/Welcome.vue"),
    name: RouteNames.WELCOME_ROUTE + "2"
  },
  {
    path: '/list',
    component: () => import("@/views/ListView.vue"),
    name: RouteNames.LIST_VIEW_ROUTE
  },
  {
    path: '/rptlst',
    component: () => import("@/views/ListView.vue"),
    name: RouteNames.REPORT_LIST_ROUTE
  },
  {
    path: '/edit',
    component: () => import( "@/views/EditView.vue"),
    name: RouteNames.EDIT_VIEW_ROUTE
  },
  {
    path: '/rpt',
    component: () => import("@/views/ReportLauncher.vue"),
    name: RouteNames.LAUNCH_REPORT_ROUTE
  },
  {
    path: '/rptres',
    component: () => import("@/views/ReportViewer.vue"),
    name: RouteNames.REPORT_RESULT_ROUTE
  },
  {
    path: '/settings',
    component: () => import("@/views/SettingsView.vue"),
    name: RouteNames.SETTINGS_ROUTE
  },
  {
    path: "/utils",
    name: RouteNames.UTILS_ROUTE,
    component: () => import("@/views/Utils.vue"),
    children: [
      {
        path: "viewusers",
        name: RouteNames.VIEW_USERS_ROUTE,
        component: () => import("@/views/UtilsViewUsers.vue"),
      },
      {
        path: "monitortasks",
        name: RouteNames.MONITOR_TASKS_ROUTE,
        component: () => import("@/views/UtilsMonitorTasks.vue"),
      },
      {
        path: "sql",
        name: RouteNames.SQL_RUNNER_ROUTE,
        component: () => import("@/views/UtilsSQLRunner.vue"),
      },
      {
        path: "websocketsessions",
        name: RouteNames.WEBSOCKET_SESSIONS,
        component: () => import("@/views/UtilsWebsocketSessions.vue"),
      },
    ]
  },
  {
    path: '/wizard',
    component: () => import("@/components/wizard/WizardPage.vue"),
    name: RouteNames.WIZARD_ROUTE
  },
  {
    path: '/impl-backup',
    component: () => import("@/views/ImplBackupBrowser.vue"),
    name: RouteNames.IMPL_BACKUP_BROWSER
  },
  {
    path: '/tech-appointment',
    component: () => import("@/views/TechnicianAppointmentCreator.vue"),
    name: RouteNames.TECHNICIAN_CALENDAR_ROUTE,
    meta: {secured: editViewTechnicianAppointments}
  },
  {
    path: '/my-appointments',
    component: () => import("@/views/MyAppointments.vue"),
    name: RouteNames.MY_APPOINTMENTS_ROUTE,
    meta: {secured: listViewTechnicianAppointments}
  },
  {
    path: '/layoutEditor',
    component: () => import("@/views/LayoutEditorPage.vue"),
    name: RouteNames.LAYOUT_EDITOR_ROUTE
  },
  {
    path: '/reportWizardEditor',
    component: () => import("@/views/ReportWizardEditorPage.vue"),
    name: RouteNames.REPORT_WIZARD_EDITOR_ROUTE
  },
  {
    path: '/fileEditor',
    component: () => import("@/views/FileEditorPage.vue"),
    name: RouteNames.FILE_EDITOR_ROUTE
  },
  {
    path: '/editfile',
    component: () => import("@/views/FileEditorPage.vue"),
    name: RouteNames.FILE_EDITOR_ROUTE + "Legacy"
  },
  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import("@/views/Welcome.vue"),
  },
];

export default routes;
